(function () {
  "use strict";

  var elem = document.querySelectorAll(".homepage-sign-message__slide");
  var slideArr = [];
  elem.forEach((el, index) => {
    slideArr[index] = new Flickity(el, {
      prevNextButtons: false,
      pageDots: false,
      freeScroll: false,
      cellAlign: "left",
      groupCells: true,
      autoPlay: 5000,
      // "contain": true,
      // "initialIndex": 0,
      // "cellAlign": "center",
      // "wrapAround": true
    });
  });

  var instructionElem = document.querySelectorAll(
    ".instruction-section__carousel",
  );
  var instructionSlideArr = [];
  instructionElem.forEach((el, index) => {
    instructionSlideArr[index] = new Flickity(el, {
      arrowShape: "M 25,50 L 60,90 L 65,85 L 35,50  L 65,15 L 60,10 Z",
      cellAlign: "left",
      contain: true,
      initialIndex: 0,
      cellAlign: "center",
      wrapAround: true,
    });
  });
})();
